import { MORTGAGE_PROMO_TYPES } from '../../constants/promos';
import { IPromoInfoSchema } from '../../types/promo';
import { TApplicationState } from '../../types/redux';

export const selectMortgagePromos = (state: TApplicationState): IPromoInfoSchema[] => {
  const promos: IPromoInfoSchema[] = state.newbuilding.promoInfos || [];

  return promos.filter(promo => MORTGAGE_PROMO_TYPES.includes(promo.promoType));
};
